import React, {useEffect, useState} from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ModelingForm from "./modeling-form/modeling-form.component";

import "./submit-remote-modeling.styles.scss";
import {getRemoteModelingPageData} from "../../../../js/api/modelingforms/_submitRemoteModeling.data"
import Loader from '../../../../components/commons/helpers/loader/loader.component';
import {useSelector} from "react-redux";
import RemoteModeling from "../../../ecommerce/filtered-login-info/remote-modeling-account-component";

const SubmitRemoteModelingForm = ({hasRemoteModelingAccount, onFormSubmit}) => {

    //#RP - Task 72 - Submit Remote modeling
    const [responseMainContent, setResponseMainContent] = useState({});
    const [remotemodeling, setRemotemodeling] = useState();
    const [status, setStatus] = useState(null);
    const [noContent] = useState(204);
    const hasBRMSKey = useSelector(({client}) => client.brmsKey);

    useEffect(() => {
        const fetchData = async () => {
            const getResponse = await getRemoteModelingPageData();

            if (getResponse) {
                setStatus(getResponse.status);
                setResponseMainContent(getResponse.MainContent);
                setRemotemodeling(getResponse.RemoteModeling);
            }
        };
        fetchData();
    }, []);

    if (hasBRMSKey.length === 0) {
        return <RemoteModeling/>
    }

    if (hasRemoteModelingAccount) {
        return <RemoteModeling/>;
    }

    if (status === noContent || (responseMainContent && remotemodeling && responseMainContent.Content != null)) {

        var content = status !== noContent && responseMainContent.Content != null ? responseMainContent.Content : "";
        var subTitle = status !== noContent && responseMainContent.SubTitle != null ? responseMainContent.SubTitle : "";
        var leftContent = status !== noContent && responseMainContent.LeftContent != null ? responseMainContent.LeftContent : "";
        var rightContent = status !== noContent && responseMainContent.RightContent != null ? responseMainContent.RightContent : "";

        return (
            <div className="trinity-container">
                <div className="modeling-content-container">
                    <div className="top-content">
                        <p className="content" dangerouslySetInnerHTML={{__html: content}}/>
                        <Row>
                            <Col xs={12} sm={6}>
                                <div className="left-content">
                                    <p className="content-title" dangerouslySetInnerHTML={{__html: subTitle}}/>
                                    <p className="content" dangerouslySetInnerHTML={{__html: leftContent}}/>
                                </div>
                            </Col>
                            <Col xs={12} sm={6}>
                                <p className="content" dangerouslySetInnerHTML={{__html: rightContent}}/>
                            </Col>
                        </Row>
                    </div>
                </div>
                <ModelingForm
                    mainData={responseMainContent}
                    status={status}
                    onFormSubmit={onFormSubmit}
                    remotemodeling={remotemodeling}
                />
            </div>
        );
    }

    return <Loader/>;
};

export default SubmitRemoteModelingForm;
